<div class="redirection-page">
  <div class="error-popup">
    <!-- Ícone de alerta -->
    <div class="error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>

    <!-- Título do erro -->
    <h1 class="error-title">{{ errorMessage }}</h1>

    <!-- Botão de retorno -->
    <button class="btn-return" (click)="returnToPrevious()">
      Retornar
    </button>
  </div>
</div>
